export default __webpack_public_path__ + "static/media/businessman-2606509_640.5e04982c.jpg";